<script setup>
import { useRoute, useRouter } from 'vue-router';
import SimuladorModal from 'dashboard/components/widgets/conversation/SimuladorClt/SimuladorModal.vue';

// ============================================================================
// v106: SIMULADOR CLT pelo MENU lateral (pedido do Kairo 06/07).
// Reusa o SimuladorModal INTEIRO passando um chat "fake" { id: 'menu' }:
// - sender cai em {} -> ficha abre VAZIA (NAO puxa CPF do contato — desejado);
// - o cache de estado usa a chave própria 'chat-menu' (não colide com as
//   conversas reais).
// Fechar o modal volta para a tela de conversas.
//
// v42: o botão DIGITAR da "Simulação e Digitação" chega aqui com ?cpf=&celular=
// na URL. Nesse caso o chat fake vira { id: 'menu-<cpf>' } com o CPF/telefone
// no sender — o modal preenche a ficha sozinho (mesmo caminho do contato real)
// e cada cliente ganha seu próprio cache de estado. O nome NÃO é passado de
// propósito: v94 manda o nome vir do Enriquecer.
// ============================================================================

const router = useRouter();
const route = useRoute();

const soDigitos = v => String(v || '').replace(/\D+/g, '');
const cpfQuery = soDigitos(route.query?.cpf).slice(0, 11);
const FAKE_CHAT = cpfQuery
  ? {
      id: `menu-${cpfQuery}`,
      meta: {
        sender: {
          custom_attributes: { cpf: cpfQuery },
          phone_number: soDigitos(route.query?.celular),
        },
      },
    }
  : { id: 'menu' };

const fechar = () => {
  router.push({ name: 'home', params: { ...router.currentRoute.value.params } });
};
</script>

<template>
  <div class="w-full h-full bg-n-background">
    <SimuladorModal :current-chat="FAKE_CHAT" @close="fechar" />
  </div>
</template>
